import { memo } from "react";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { OnboardingApplicationStatus as OnboardingApplicationStatusComponent } from "ui/molecules/Status";
import When from "ui/support/When";
import type { OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges } from "../types";

const FromApplicationStatus = ({ row }: GridRenderCellParams<OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges>) => {
    const { changes } = row;

    const fromStatus = changes
        ?.status
        ?.at(-2);

    return (
        <When
            if={Boolean(fromStatus)}
            then={() => (
                <OnboardingApplicationStatusComponent
                    label={fromStatus}
                />
            )}
        >
            -
        </When>
    );
};

export default memo(FromApplicationStatus);
